@for (attribute of attributes; track $index) {
@switch (displayDropdown(attribute.code)) {
@default {
@if (!attribute.hidden) {
<div [ngClass]="smallVariant ? 'm-t-2' : 'm-t'">
    <!-- title line -->
    <h6 [ngClass]="smallVariant ? 'p3' : 'p1 m-b-1'">
        @if (hasSelection(attribute)) {
        {{ attribute.model.data!.label }}: {{ getSelection(attribute) | optionLabel : attribute.code }}
        } @else {
        {{ 'Select %' | translate : attribute.model.data!.label }}
        }
    </h6>
    @switch (attribute.model.data!.isSwatch) {
    <!-- swatches -->
    @case (true) {
    <div>
        @for (option of attribute.options; track $index) {
        <swatch class="inline-block va-m cursor-pointer m-t-1 m-r-1"
                [class.is-oos]="!option.salable"
                [option]="option"
                [optionSmall]="smallVariant"
                [configurableOptionWarningTrigger]="{ attribute: attribute, option: option }"
                [selected]="isPicked(attribute, option)"
                (click)="pick(attribute, option)"></swatch>
        }
    </div>
    }
    <!-- regular options  -->
    @default {
    <div>
        @for (option of attribute.options; track $index) {
        <div class="inline-block cursor-pointer m-t-1 m-r-1 p-a-3 b-a p1"
             [ngClass]="isPicked(attribute, option) ? 'b-col-1' : 'b-col-4'"
             [class.disabled]="hasWarning(option) || isDisabled(option)"
             (click)="pick(attribute, option)">
            {{option.label}}
        </div>
        }
    </div>
    }
    }
</div>
}
<!-- size guide -->
@if (hasSizeGuide(attribute) && !smallVariant) {
<button class="block button-inline-5 m-t-2 p1"
        (click)="openSizeGuide()">
    {{'View size guide' | translate}}
</button>
}
}
@case (true) {
<!-- size guide mobile -->
@if (hasSizeGuide(attribute) && !smallVariant) {
<div *ifSize="'SM'"
     class="w-12 right">
    <button class="inline-block m-t-2 p2 underline italic col-11"
            style="text-decoration-color: currentColor;"
            (click)="openSizeGuide()">{{'View size guide' | translate}}
    </button>
</div>
}

<h6 [ngClass]="smallVariant ? 'p3 m-t-2' : 'p1 m-t'">
    @switch (hasSelection(attribute)) {
    @case (true) {
    {{ attribute.model.data!.label }}: {{ getSelection(attribute) | optionLabel : attribute.code }}
    }
    <!-- unselected -->
    @default {
    {{ 'Select %' | translate : attribute.model.data!.label }}<span class="col-2">*</span>
    }
    }
    <!-- selected -->
</h6>
<product-configurable-option-dropdown [value]="getOption(attribute.code, getSelection(attribute) || 0)"
                                      [multipleVariant]="isAttributeMultiple(attribute.code)"
                                      [displayWarnings]="displayDropdownWarnings"
                                      (valueChange)="pick(attribute, $event)"
                                      class="block"
                                      [attr]="attribute">
    @if (hasSizeGuide(attribute)) {
    <button class="inline-block m-t-2 p2 underline italic col-11"
            style="text-decoration-color: currentColor;"
            (click)="openSizeGuide()">{{'View size guide' | translate}}
    </button>
    }
</product-configurable-option-dropdown>
<sizebay #sizebayRef></sizebay>
<!-- size guide desktop -->
@if (hasSizeGuide(attribute) && !smallVariant) {
<div *ifSize="'XL'"
     class="w-12 right">
    <button class="inline-block m-t-2 p2 underline italic col-11"
            style="text-decoration-color: currentColor;"
            (click)="openSizeGuide()">{{'View size guide' | translate}}
    </button>
</div>
}
}
}
}